import  gql  from 'graphql-tag'

export const SEND_ERRORS = gql`mutation sendErrors($input: SendErrorsInput!){
    sendErrors(input: $input){
        clientMutationId
    }
}`;